import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const ContactSection = () => {
  const handleContactClick = () => {
    window.open('https://forms.gle/r4yo23GVpmH5Dgc19', '_blank');
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-6xl font-black text-gray-900 mb-6 font-din tracking-tight">
            <span className="text-transparent bg-gradient-to-r from-green-500 to-blue-600 bg-clip-text py-2 px-1">売れるサムネイル</span>は、<br />
            最短<span className="text-green-600 font-extrabold number-font-bold">1</span>日で作れる。
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto font-body leading-relaxed mb-12">
            撮影の手配・費用・スケジュールに悩む必要はもうありません。<br/>3Dモックアップで、低コスト・高品質・短納期を実現します。
          </p>
        </div>

        <div className="flex justify-center">
          <Button 
            onClick={handleContactClick}
            className="bg-gradient-to-r from-blue-500 to-green-500 hover:from-blue-600 hover:to-green-600 text-white px-12 py-8 text-2xl font-bold rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group"
          >
            無料でお見積もりを依頼する
            <ArrowRight className="ml-3 h-7 w-7 group-hover:translate-x-2 transition-transform" />
          </Button>
        </div>

        <p className="text-center text-gray-600 mt-8 text-lg">
          見積もり無料 ／ 最短当日返信
        </p>
      </div>
    </section>
  );
};

export default ContactSection;